import { baseSplitApiClaims as api } from "./config/baseApiClaims";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getDamageGenericLocations: build.query<
      GetDamageGenericLocationsApiResponse,
      GetDamageGenericLocationsApiArg
    >({
      query: (queryArg) => ({
        url: `/claims/decoding-tables/damage-generic-locations`,
        params: { vehicleType: queryArg.vehicleType },
      }),
    }),
    createClaimDraft: build.mutation<
      CreateClaimDraftApiResponse,
      CreateClaimDraftApiArg
    >({
      query: (queryArg) => ({
        url: `/claims/`,
        method: "POST",
        body: queryArg.createdClaim,
      }),
    }),
    getClaim: build.query<GetClaimApiResponse, GetClaimApiArg>({
      query: (queryArg) => ({ url: `/claims/${queryArg.id}` }),
    }),
    updateClaim: build.mutation<UpdateClaimApiResponse, UpdateClaimApiArg>({
      query: (queryArg) => ({
        url: `/claims/${queryArg.id}`,
        method: "PUT",
        body: queryArg.updatedClaim,
      }),
    }),
    deleteClaimDraft: build.mutation<
      DeleteClaimDraftApiResponse,
      DeleteClaimDraftApiArg
    >({
      query: (queryArg) => ({
        url: `/claims/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getSubjectsVersionByClaim: build.query<
      GetSubjectsVersionByClaimApiResponse,
      GetSubjectsVersionByClaimApiArg
    >({
      query: (queryArg) => ({
        url: `/claims/${queryArg.claimId}/subjects/${queryArg.subjectId}`,
      }),
    }),
    changeClaimPolicy: build.mutation<
      ChangeClaimPolicyApiResponse,
      ChangeClaimPolicyApiArg
    >({
      query: (queryArg) => ({
        url: `/claims/${queryArg.id}/change-policy`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    searchClaims: build.mutation<SearchClaimsApiResponse, SearchClaimsApiArg>({
      query: (queryArg) => ({
        url: `/claims/search`,
        method: "POST",
        body: queryArg.searchClaimsParams,
        params: {
          pageNum: queryArg.pageNum,
          pageLen: queryArg.pageLen,
          scenario: queryArg.scenario,
          activeRole: queryArg.activeRole,
        },
      }),
    }),
    getClaimsCompanies: build.query<
      GetClaimsCompaniesApiResponse,
      GetClaimsCompaniesApiArg
    >({
      query: () => ({ url: `/claims/companies` }),
    }),
    createOrUpdateClaimsCompanyData: build.mutation<
      CreateOrUpdateClaimsCompanyDataApiResponse,
      CreateOrUpdateClaimsCompanyDataApiArg
    >({
      query: (queryArg) => ({
        url: `/claims/companies`,
        method: "POST",
        body: queryArg.claimsCompany,
      }),
    }),
    getClaimsCompanyData: build.query<
      GetClaimsCompanyDataApiResponse,
      GetClaimsCompanyDataApiArg
    >({
      query: (queryArg) => ({ url: `/claims/companies/${queryArg.id}` }),
    }),
    getClaimsSummaryA1: build.query<
      GetClaimsSummaryA1ApiResponse,
      GetClaimsSummaryA1ApiArg
    >({
      query: (queryArg) => ({
        url: `/claims/summary/A1`,
        params: { tenants: queryArg.tenants },
      }),
    }),
    getClaimHistory: build.query<
      GetClaimHistoryApiResponse,
      GetClaimHistoryApiArg
    >({
      query: (queryArg) => ({ url: `/claims/${queryArg.id}/history` }),
    }),
    createDamageLot: build.mutation<
      CreateDamageLotApiResponse,
      CreateDamageLotApiArg
    >({
      query: (queryArg) => ({
        url: `/claims/${queryArg.claimId}/damagelots/`,
        method: "POST",
        body: queryArg.createdDamageLot,
      }),
    }),
    getDamageLotsList: build.query<
      GetDamageLotsListApiResponse,
      GetDamageLotsListApiArg
    >({
      query: (queryArg) => ({ url: `/claims/${queryArg.claimId}/damagelots/` }),
    }),
    getDamageLot: build.query<GetDamageLotApiResponse, GetDamageLotApiArg>({
      query: (queryArg) => ({
        url: `/claims/${queryArg.claimId}/damagelots/${queryArg.id}`,
      }),
    }),
    deleteDamageLot: build.mutation<
      DeleteDamageLotApiResponse,
      DeleteDamageLotApiArg
    >({
      query: (queryArg) => ({
        url: `/claims/${queryArg.claimId}/damagelots/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    updateDamageLot: build.mutation<
      UpdateDamageLotApiResponse,
      UpdateDamageLotApiArg
    >({
      query: (queryArg) => ({
        url: `/claims/${queryArg.claimId}/damagelots/${queryArg.id}`,
        method: "PUT",
        body: queryArg.createdDamageLot,
      }),
    }),
    addDamage: build.mutation<AddDamageApiResponse, AddDamageApiArg>({
      query: (queryArg) => ({
        url: `/damagelots/${queryArg.damageLotId}/damages/`,
        method: "POST",
        body: queryArg.damage,
      }),
    }),
    getDamage: build.query<GetDamageApiResponse, GetDamageApiArg>({
      query: (queryArg) => ({
        url: `/damagelots/${queryArg.damageLotId}/damages/${queryArg.id}`,
      }),
    }),
    deleteDamage: build.mutation<DeleteDamageApiResponse, DeleteDamageApiArg>({
      query: (queryArg) => ({
        url: `/damagelots/${queryArg.damageLotId}/damages/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    updateDamage: build.mutation<UpdateDamageApiResponse, UpdateDamageApiArg>({
      query: (queryArg) => ({
        url: `/damagelots/${queryArg.damageLotId}/damages/${queryArg.id}`,
        method: "PUT",
        body: queryArg.damage,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as apiClaims };
export type GetDamageGenericLocationsApiResponse =
  /** status 200 a JSON representing data */ DecodingTableData;
export type GetDamageGenericLocationsApiArg = {
  /** vehicle type code */
  vehicleType: string;
};
export type CreateClaimDraftApiResponse =
  /** status 200 a JSON representing the current claim */ ReadOnlyClaim;
export type CreateClaimDraftApiArg = {
  createdClaim: CreatedClaim;
};
export type GetClaimApiResponse =
  /** status 200 a JSON representing the current claim */ ReadOnlyClaim;
export type GetClaimApiArg = {
  /** Numeric Id of the resource */
  id: number;
};
export type UpdateClaimApiResponse =
  /** status 200 a JSON representing the current claim */ ReadOnlyClaim;
export type UpdateClaimApiArg = {
  /** Numeric Id of the resource */
  id: number;
  updatedClaim: UpdatedClaim;
};
export type DeleteClaimDraftApiResponse = unknown;
export type DeleteClaimDraftApiArg = {
  /** Numeric Id of the resource */
  id: number;
};
export type GetSubjectsVersionByClaimApiResponse =
  /** status 200 a JSON representing subject'd data */ Subject;
export type GetSubjectsVersionByClaimApiArg = {
  /** resource id */
  claimId: number;
  /** resource id */
  subjectId: number;
};
export type ChangeClaimPolicyApiResponse =
  /** status 200 a JSON representing the current claim */ ReadOnlyPolicy;
export type ChangeClaimPolicyApiArg = {
  /** Numeric Id of the resource */
  id: number;
  body: number;
};
export type SearchClaimsApiResponse =
  /** status 200 a searched claims list */ SearchedClaimsList;
export type SearchClaimsApiArg = {
  /** result page number */
  pageNum: number;
  /** result page item list */
  pageLen: number;
  /** identifie the scenario to get items list from the correct source */
  scenario: string;
  /** the active role selected by the user */
  activeRole: string;
  searchClaimsParams: SearchClaimsParams;
};
export type GetClaimsCompaniesApiResponse =
  /** status 200 a JSON representing claims companies list data */ ClaimsCompanyItem[];
export type GetClaimsCompaniesApiArg = void;
export type CreateOrUpdateClaimsCompanyDataApiResponse =
  /** status 200 a JSON representing a claims company data */ ClaimsCompany;
export type CreateOrUpdateClaimsCompanyDataApiArg = {
  claimsCompany: ClaimsCompany;
};
export type GetClaimsCompanyDataApiResponse =
  /** status 200 a JSON representing a claims company data */ ClaimsCompany;
export type GetClaimsCompanyDataApiArg = {
  /** Numeric Id of the resource */
  id: number;
};
export type GetClaimsSummaryA1ApiResponse =
  /** status 200 a JSON representing a claims company data */ DashboardA1Summary;
export type GetClaimsSummaryA1ApiArg = {
  /** enabled tenants */
  tenants: number[];
};
export type GetClaimHistoryApiResponse =
  /** status 200 a JSON describing an array of history logs */
    | ClaimHistoryList
    | /** status 204 The request was correct but the item does not exists */ {
        message?: string;
      };
export type GetClaimHistoryApiArg = {
  /** Numeric Id of the resource */
  id: number;
};
export type CreateDamageLotApiResponse =
  /** status 200 a JSON representing a claims company data */ ReadOnlyDamageLot;
export type CreateDamageLotApiArg = {
  /** resource id */
  claimId: number;
  createdDamageLot: CreatedDamageLot;
};
export type GetDamageLotsListApiResponse =
  /** status 200 a JSON representing a claims company data */ DamageLotsList;
export type GetDamageLotsListApiArg = {
  /** resource id */
  claimId: number;
};
export type GetDamageLotApiResponse =
  /** status 200 a JSON representing a claims company data */ ReadOnlyDamageLot;
export type GetDamageLotApiArg = {
  /** resource id */
  claimId: number;
  /** Numeric Id of the resource */
  id: number;
};
export type DeleteDamageLotApiResponse =
  /** status 204 a JSON representing a claims company data */ undefined;
export type DeleteDamageLotApiArg = {
  /** resource id */
  claimId: number;
  /** Numeric Id of the resource */
  id: number;
};
export type UpdateDamageLotApiResponse =
  /** status 200 a JSON representing a claims company data */ ReadOnlyDamageLot;
export type UpdateDamageLotApiArg = {
  /** resource id */
  claimId: number;
  /** Numeric Id of the resource */
  id: number;
  createdDamageLot: CreatedDamageLot;
};
export type AddDamageApiResponse =
  /** status 200 a JSON representing a claims company data */ ReadOnlyDamageLot;
export type AddDamageApiArg = {
  /** resource id */
  damageLotId: number;
  damage: Damage;
};
export type GetDamageApiResponse =
  /** status 200 a JSON representing a claims company data */ Damage;
export type GetDamageApiArg = {
  /** resource id */
  damageLotId: number;
  /** Numeric Id of the resource */
  id: number;
};
export type DeleteDamageApiResponse =
  /** status 204 a JSON representing a claims company data */ undefined;
export type DeleteDamageApiArg = {
  /** resource id */
  damageLotId: number;
  /** Numeric Id of the resource */
  id: number;
};
export type UpdateDamageApiResponse =
  /** status 200 a JSON representing a claims company data */ ReadOnlyDamageLot;
export type UpdateDamageApiArg = {
  /** resource id */
  damageLotId: number;
  /** Numeric Id of the resource */
  id: number;
  damage: Damage;
};
export type DecodingTableRow = {
  id?: number;
  code?: string;
  description?: string;
};
export type DecodingTableData = DecodingTableRow[];
export type ClaimAddress = {
  city?: string;
  civic?: string;
  country?: string;
  latitude?: number;
  longitude?: number;
  postalCode?: string;
  province?: string;
  street?: string;
};
export type Event = ClaimAddress & {
  date?: string;
  time?: string;
};
export type CreatedClaim = Event & {
  companyId?: number;
  policyId?: number;
  claimsBranchCode?: string;
};
export type UpdatedClaim = {
  id?: number;
  reportingDate?: string;
  companyReceiptDate?: string;
  receiptDate?: string;
  customerReferenceNumber?: string;
  uciReferenceNumber?: string;
  consapReferenceNumber?: string;
  branchGroupId?: number;
};
export type Vehicle = {
  id?: number;
  plateNumber?: string;
  chassisNumber?: string;
  type?: string;
  brand?: string;
  model?: string;
};
export type Guarantee = {
  id?: number;
  branch?: string;
  excessAmount?: number;
  overdraftAmount?: number;
};
export type BasePolicy = {
  id?: number;
  numberCompany?: string;
  tenantId?: number;
  effectDate?: string;
  expirationDate?: string;
  administrativeCompliance?: boolean;
  insuredProperty?: Vehicle;
  guarantees?: Guarantee[];
};
export type PolicySubject = {
  id?: number;
  subjectName?: string;
  subjectTaxId?: string;
  roleCode?: string;
};
export type ReadOnlyPolicy = BasePolicy & {
  number?: string;
  company?: string;
  policySubjects?: PolicySubject[];
};
export type BirthDateAndPlace = {
  date?: string;
  city?: string;
  province?: string;
  country?: string;
};
export type Address = {
  id?: number;
  type?: string;
  street?: string;
  civic?: string;
  postalCode?: string;
  city?: string;
  province?: string;
  country?: string;
  latitude?: number;
  longitude?: number;
  preferred?: boolean;
  isDeleted?: boolean;
  isIncorrect?: boolean;
};
export type Contact = {
  id?: number;
  type?: string;
  value?: string;
  description?: string;
  useCase?: string;
  preferred?: boolean;
  isDeleted?: boolean;
};
export type SubjectDocument = {
  id?: number;
  documentCode?: string;
  type?: string;
  number?: string;
  issuingDate?: string;
  expirationDate?: string;
  issuingInstitution?: string;
};
export type SubjectPayment = {
  id?: number;
  type?: string;
  iban?: string | null;
  bicSwift?: string | null;
  addressSendCheck?: Address | null;
  preferred?: boolean;
};
export type Subject = {
  id?: number;
  subjectType?: string;
  name?: string;
  lastname?: string;
  gender?: string;
  fiscalCode?: string;
  birth?: BirthDateAndPlace | null;
  businessName?: string;
  giuridicalType?: string;
  registeredOffice?: Address | null;
  pIva?: string;
  contacts?: Contact[] | null;
  addresses?: Address[] | null;
  documents?: SubjectDocument[] | null;
  payments?: SubjectPayment[] | null;
};
export type CounterpartyVehicle = Vehicle & {
  id?: number;
  insuranceCompany?: string;
  insuranceCompanyCode?: string;
  hasFleetPolicy?: boolean;
  hasBlackBox?: boolean;
  isResponsibleOrDamaged?: string;
  owner?: Subject;
  driver?: Subject & {
    sameAsOwner?: boolean;
  };
};
export type ReadOnlyClaim = CreatedClaim &
  UpdatedClaim & {
    status?: string;
    creationDate?: string;
    company?: string;
    number?: string;
    branchGroup?: string;
    isCard?: boolean;
    isManaged?: boolean;
    openingDate?: string;
    conclusionDate?: string;
    compensationAdjuster?: string;
    isReopened?: string;
    reportingDate?: string;
    companyReceiptDate?: string;
    receiptDate?: string;
    customerReferenceNumber?: string;
    uciReferenceNumber?: string;
    consapReferenceNumber?: string;
    policy?: ReadOnlyPolicy;
    counterparties?: CounterpartyVehicle[];
  };
export type SearchedClaimsItem = {
  id?: number;
  companyId?: number;
  claimNumber?: string;
  custoReferenceNumber?: string;
  claimType?: string;
  claimStatusCode?: string;
  claimWorkflow?: string;
  signatureTypeCode?: string;
  plateNumberList?: string[];
  policyNumber?: string;
  subjectName?: string;
  subjectTaxId?: string;
  lossAdjuster?: string;
  openingDate?: string;
};
export type SearchedClaimsList = {
  totalCount?: number;
  currentPageNum?: number;
  totalPageNum?: number;
  pageLen?: number;
  items?: SearchedClaimsItem[];
};
export type SearchClaimsParams = {
  companyList?: number[];
  claimNumberList?: string[];
  claimType?: string;
  claimStatus?: string;
  claimWorkflow?: string;
  subjectName?: string;
  subjectTaxId?: string;
  plateNumberList?: string[];
  policyNumber?: string;
  isReopened?: boolean;
};
export type ClaimsCompanyItem = {
  id?: number;
  businessName?: string;
};
export type ClaimsCompany = {
  registryInfo?: Subject;
  department?: string;
  coordinationCenterId?: number;
  group?: string;
  isBillingEnabled?: boolean;
  sapCode?: string;
  aniaCode?: string;
  uciCode?: string;
  notes?: string;
  lossProvisionDefaults?: {
    injuriesAmount?: number;
    vehiclesAmount?: number;
    propertiesAmount?: number;
  };
};
export type TotalByCategory = {
  category?: string;
  total?: number;
};
export type DashboardA1Summary = {
  inDraft?: TotalByCategory[];
  inProgress?: TotalByCategory[];
  inProgressReopened?: TotalByCategory[];
};
export type Modifydetail = {
  key?: string;
  value?: string;
};
export type ClaimHistory = {
  id?: number;
  entityType?: string;
  modifyType?: string;
  modifyDescription?: string;
  isFrontend?: boolean;
  modifyUser?: string;
  modifyTimestamp?: string;
  claimStatus?: string;
  lossAdjuster?: string;
  modifyDetailsJson?: Modifydetail[];
};
export type ClaimHistoryList = ClaimHistory[];
export type Schema = {
  errorCode?: string;
  errorMessage?: string;
};
export type CreatedDamageLot = {
  roleCode?: string;
  subjectId?: number;
  managementTypeCode?: string;
  damageConventionTypeCode?: string;
};
export type Amounts = {
  passiveStock?: number;
  recoveryStock?: number;
  requestedAmount?: number;
  paidAmount?: number;
};
export type ReadOnlyDamageLot = CreatedDamageLot &
  Amounts & {
    status?: string;
    damages?: any;
  };
export type DamageLotMainData = Amounts & {
  id?: number;
  subjectId?: number;
  subjectName?: string;
  roleCode?: string;
  status?: string;
  vehiclePlateNumber?: string;
  hasvehicleDamage?: boolean;
  hasPersonalInjury?: boolean;
  hasPropertyDamage?: boolean;
};
export type DamageLotsList = DamageLotMainData[];
export type Injury = {
  injuryTypeCode?: string;
  injuryLocationCode?: string;
};
export type PersonalInjury = {
  permanentDisabilityPercentage?: number;
  emergencyDepartmentCode?: string;
  decease?: boolean;
  injuries?: Injury[];
};
export type VehicleDamage = {
  collisionPointCodes?: string[];
};
export type Damage = Amounts &
  PersonalInjury &
  VehicleDamage & {
    damageTypeCode?: string;
    notes?: string;
  };
export const {
  useGetDamageGenericLocationsQuery,
  useLazyGetDamageGenericLocationsQuery,
  useCreateClaimDraftMutation,
  useGetClaimQuery,
  useLazyGetClaimQuery,
  useUpdateClaimMutation,
  useDeleteClaimDraftMutation,
  useGetSubjectsVersionByClaimQuery,
  useLazyGetSubjectsVersionByClaimQuery,
  useChangeClaimPolicyMutation,
  useSearchClaimsMutation,
  useGetClaimsCompaniesQuery,
  useLazyGetClaimsCompaniesQuery,
  useCreateOrUpdateClaimsCompanyDataMutation,
  useGetClaimsCompanyDataQuery,
  useLazyGetClaimsCompanyDataQuery,
  useGetClaimsSummaryA1Query,
  useLazyGetClaimsSummaryA1Query,
  useGetClaimHistoryQuery,
  useLazyGetClaimHistoryQuery,
  useCreateDamageLotMutation,
  useGetDamageLotsListQuery,
  useLazyGetDamageLotsListQuery,
  useGetDamageLotQuery,
  useLazyGetDamageLotQuery,
  useDeleteDamageLotMutation,
  useUpdateDamageLotMutation,
  useAddDamageMutation,
  useGetDamageQuery,
  useLazyGetDamageQuery,
  useDeleteDamageMutation,
  useUpdateDamageMutation,
} = injectedRtkApi;
